import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../Store";

interface AuthenticationState {
  email: string;
  jwt: string;
  organizationIDs: string[];
  authenticated: boolean;
  userID: string;
  refreshToken: string;
}

const initialState: AuthenticationState = {
  email: localStorage.getItem("email") || "",
  jwt: localStorage.getItem("jwt") || "",
  organizationIDs: [],
  authenticated: false,
  userID: localStorage.getItem("userID") || "",
  refreshToken: localStorage.getItem("refreshToken") || "",
};

// authentication slice
export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setAuthenticationSuccess: (
      state,
      action: PayloadAction<{
        email: string;
        jwt: string;
        userID: string;
        organizationIDs: string[];
        refreshToken: string;
      }>
    ) => {
      state.email = action.payload.email;
      state.jwt = action.payload.jwt;
      state.userID = action.payload.userID;
      state.organizationIDs = action.payload.organizationIDs;
      state.refreshToken = action.payload.refreshToken;
    },
    setReauthenticationSuccess: (state, action) => {
      state.jwt = action.payload.jwt;
      state.organizationIDs = action.payload.organizationIDs;
      state.userID = action.payload.userID;
      state.refreshToken = action.payload.refreshToken;
    },
    setIsAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.authenticated = action.payload;
    },
    setLogout: (state) => {
      state.jwt = "";
      state.organizationIDs = [];
      state.userID = "";
      state.refreshToken = "";
      state.authenticated = false;
      state.email = "";
    },
  },
});

// reducers
export const {
  setAuthenticationSuccess,
  setReauthenticationSuccess,
  setLogout,
  setIsAuthenticated,
} = authenticationSlice.actions;

// selectors
export const selectUsername = (state: RootState) => state.authentication.email;
export const selectAuthenticated = (state: RootState) =>
  state.authentication.authenticated;
export const selectToken = (state: RootState) => state.authentication.jwt;
export const selectUserID = (state: RootState) => state.authentication.userID;
export const selectRefreshToken = (state: RootState) =>
  state.authentication.refreshToken;
export default authenticationSlice.reducer;
